import React from "react"
import { graphql } from "gatsby"
import PrimaryLayout from "../layouts/PrimaryLayout"
import Post from "../components/Post"

//creating arrow function and get rid of function keyword and curly braces
//you always need a wrapping element that returns all the nested elements
export default ({ data }) => {
  return (
    <PrimaryLayout column="col-sm-8">
      {data.allWordpressPost.nodes.map(node => (
        <Post
          alt={node.featured_media.slug}
          image={node.featured_media.source_url}
          title={node.title}
          excerpt={node.excerpt}
          readMore={node.slug}
        />
      ))}
    </PrimaryLayout>
  )
}
export const query = graphql`
  {
    allWordpressPost {
      nodes {
        slug
        title
        excerpt
        featured_media {
          source_url
          slug
        }
      }
    }
  }
`
